<script>
import Lottie from 'vue-lottie'
import * as checkAnimation from '@assets/animations/lottie/check_animation.json'
import LOCALE from '@constants/locale'
import { BOOK_REQUEST_SUBMISSION_KEY } from '@constants/book-request'
import { downloadBookRequestPdf } from '@utils/book-request-pdf'

// Success view shown after the book-request form is submitted. Prioritizes the
// lang from the query over the global i18n locale, so it can be reused in other
// flows. The stored submission is set by book-request-ac-form.
export default {
  page() {
    const title = this.$t('WIDGETS.COMMON.REQUEST_SUBMITTED')
    return { title, meta: [{ name: 'description', content: title }] }
  },
  components: { Lottie },
  data() {
    return {
      lottieOptions: { animationData: checkAnimation.default, loop: false },
      submission: null,
    }
  },
  computed: {
    email() {
      const attrs = this.submission && this.submission.payload && this.submission.payload.Attributes
      return (attrs && attrs.email) || ''
    },
  },
  beforeCreate() {
    const lang = (this.$route.query.language || '').toLowerCase()
    const match = LOCALE.LANGUAGES.find(l => lang.startsWith(l))
    if (match) this.$i18n.locale = match
  },
  created() {
    let submission = null
    try {
      submission = JSON.parse(sessionStorage.getItem(BOOK_REQUEST_SUBMISSION_KEY))
    } catch (e) {} // eslint-disable-line no-empty
    // No submission, or a malformed one, means there's nothing to show.
    if (
      !submission ||
      typeof submission !== 'object' ||
      !submission.payload ||
      typeof submission.payload.Attributes !== 'object'
    ) {
      this.$router.replace({ name: '404' })
      return
    }
    this.submission = submission
  },
  methods: {
    downloadPdf() {
      const countryCode = (this.$route.query.country_code || '').toUpperCase()
      downloadBookRequestPdf(this.submission, countryCode)
    },
  },
}
</script>

<template>
  <div
    v-if="submission"
    :class="$style.container">
    <lottie
      :options="lottieOptions"
      :height="150"
      :width="150"
    />
    <h2 :class="$style.title">{{ $t('WIDGETS.COMMON.MESSAGE_SEND') }}</h2>
    <p :class="$style.text">
      {{ $t('WIDGETS.COMMON.CONTACT_EMAIL_REGISTERED') }}<span v-if="email">: {{ email }}</span>.
    </p>
    <p :class="$style.text">
      {{ $t('WIDGETS.COMMON.DOWNLOAD_REQUEST_COPY') }}
      <a
        :class="$style.link"
        href="#"
        @click.prevent="downloadPdf">{{ $t('WIDGETS.COMMON.HERE') }}</a>
    </p>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding-top: 6rem;
  text-align: center;
}

.title {
  margin-top: 1.5rem;
  color: $charcoal-gray;
}

.text {
  margin-top: 1rem;
  font-weight: 700;
  color: $charcoal-gray;
}

.link {
  color: $rappi-green;
  cursor: pointer;
}
</style>
